import { Form, Input, InputNumber } from "antd";
// import React, { Component } from 'react'

export const RangeInput = ({ name, label }) => {
  const placeholder = "请输入";
  const style = { width: `${97/19.2}vw` };
  let minNum = 0,
      maxNum = 999999;
  const getMinNum = (e) => {
    let res = e;
    minNum = e;
    if (res !== 0 && !res) {
      return null
    } else {
      return  res < maxNum ? res : null;
    }
  };
  const getMaxNum = (e) => {
    const res = e;
    maxNum = e;
    if (res !== 0 && !res) {
      return null
    } else {
      return  res > minNum ? res : null;
    }
  };
  const validator = (_, value)=> {
    if (value) return Promise.resolve()
  }
  const limitDecimalsF =(value)=>{
    let reg = /^(-)*(\d+)\.(\d\d).*$/;
    return `${value}`.replace(reg,'$1$2.$3');
  };
  const limitDecimalsP =(value)=>{
    let reg = /^(-)*(\d+)\.(\d\d).*$/;
    return value.replace(/￥\s?|(,*)/g, '').replace(reg,'$1$2.$3');
  };
  return (
    <div className="align-center mg-b-20">
      <span className="bold mg-r-10">{label}</span>
      <div className="site-input-group-wrapper total">
        <Input.Group compact>
          <Form.Item
            name={[name, "min"]}
            getValueFromEvent={getMinNum}
            rules={[{ validator }]}
          >
            <InputNumber
              size="large"
              className=" site-input-left"
              style={style}
              placeholder={placeholder}
              maxLength={9}
              min={0}
              max={maxNum}
              formatter={limitDecimalsF}
              parser={limitDecimalsP}
            />
          </Form.Item>
          <Input
            size="large"
            className="site-input-split"
            placeholder={"至"}
            disabled
            style={{
              width: `${36 / 19.2}vw`,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              pointerEvents: "none",
            }}
          />
          <Form.Item
            name={[name, "max"]}
            getValueFromEvent={getMaxNum}
            dependencies={[name, "min"]}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && getFieldValue(name).min) {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <InputNumber
              size="large"
              className="site-input-right"
              style={style}
              placeholder={placeholder}
              maxLength={9}
              min={minNum}
              max={999999}
              formatter={limitDecimalsF}
              parser={limitDecimalsP}
            />
          </Form.Item>
        </Input.Group>
      </div>
    </div>
  );
};
